import { render } from "./PanelTipster.vue?vue&type=template&id=660fd9d0&scoped=true"
import script from "./PanelTipster.vue?vue&type=script&lang=js"
export * from "./PanelTipster.vue?vue&type=script&lang=js"

import "./PanelTipster.vue?vue&type=style&index=0&id=660fd9d0&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-660fd9d0"]])

export default __exports__